import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { usePopper } from 'react-popper';
import { BKJDropdown } from '../../BKJDropdown/index.js';
import { mergeRefs } from '../../BKJSelect/utils/mergeRefs.js';
import { Portal } from '../../Portal/Portal.js';
import { getPopperOptions, optionsVariant } from '../BKJComboBox.utils.js';
import { useBKJComboBoxContext } from './BKJComboBox.context.js';
import { BKJComboBoxOptionsMapper } from './BKJComboBoxOptionsMapper.js';
const variantMap = {
    ComboBoxSeamlessRounded: 'SeamlessRounded',
};
export const BKJComboBoxOptions = ({ $dropdownHeight, allowedAutoPlacements = ['bottom', 'top'], overrides = [], }) => {
    const { error, isOpen, parentRef, getMenuProps, anchorElement, dropdownElement, setDropdownElement, portalTargetElement, isDropdownReverse, } = useBKJComboBoxContext();
    const popperOpts = useMemo(getPopperOptions, []);
    const popperWithAllowedAutoPlacements = useMemo(() => ({
        ...popperOpts,
        modifiers: popperOpts.modifiers.map((modifier) => ({
            ...modifier,
            ...(modifier.name === 'flip' && {
                options: {
                    ...modifier.options,
                    allowedAutoPlacements,
                },
            }),
        })),
    }), [allowedAutoPlacements, popperOpts]);
    const { styles } = usePopper(anchorElement, dropdownElement, popperWithAllowedAutoPlacements);
    return (_jsx(Portal, { targetElement: portalTargetElement, children: _jsx(BKJDropdown, { "$isOpen": isOpen, "$dropdownVariant": variantMap[optionsVariant], "$dropdownHeight": $dropdownHeight, error: error, ...getMenuProps({
                ref: mergeRefs([parentRef, setDropdownElement]),
                style: styles['popper'],
            }), openBorderLocation: isDropdownReverse ? 'bottom' : 'top', children: _jsx(BKJComboBoxOptionsMapper, { overrides: overrides }) }) }));
};
//# sourceMappingURL=BKJComboBoxOptions.js.map